import type { MemberRouteMetadata } from "../../app/routes";
import { DashboardPage } from "./DashboardPage";
import { AccountPageRouter } from "./account-router";
import { MyHomePage } from "./AccountPages";
import { BenefitCreatePage, BenefitDetailPage, BenefitListPage, InquiryCreatePage, InquiryDetailPage, InquiryListPage, NotificationPage } from "./CarePages";
import { TransactionCreatePage, TransactionDetailPage, TransactionListPage, TransactionPaymentPage } from "./TransactionPages";
import { navigate } from "../shared/ui";
import { MemberTopBar } from "./MemberMobileUi";
import { TerminationPage } from "./TerminationPage";
import { TransactionTransferPage } from "./TransactionTransferPage";
import { transactionPath } from "./transaction-groups";

function backTarget(routeId: string, params: Readonly<Record<string, string>>) {
  if (["MEM-S18", "MEM-S20"].includes(routeId) && params.transactionId) return transactionPath(`/app/transactions/${params.transactionId}`);
  if (["MEM-S03", "MEM-S04"].includes(routeId)) return transactionPath("/app/transactions");
  if (["MEM-S06", "MEM-S16"].includes(routeId)) return "/app/benefits";
  if (["MEM-S09", "MEM-S17"].includes(routeId)) return "/app/inquiries";
  return "/app/my";
}

export function MemberPage({ route, params }: {
  readonly route: MemberRouteMetadata;
  readonly params: Readonly<Record<string, string>>;
}) {
  switch (route.id) {
    case "MEM-S03": return <TransactionCreatePage />;
    case "MEM-S06": return <BenefitCreatePage />;
    case "MEM-S16": return <BenefitDetailPage claimId={Number(params.claimId)} />;
    case "MEM-S01": return <DashboardPage />;
    case "MEM-S02": return <TransactionListPage />;
    case "MEM-S04": return <TransactionDetailPage transactionId={Number(params.transactionId)} />;
    case "MEM-S05": return <BenefitListPage />;
    case "MEM-S07": return <NotificationPage />;
    case "MEM-S19": return <MyHomePage />;
    case "MEM-S15": return <TerminationPage />;
    default: {
      let content;
      switch (route.id) {
        case "MEM-S03": content = <TransactionCreatePage />; break;
        case "MEM-S18": content = <TransactionPaymentPage transactionId={Number(params.transactionId)} />; break;
        case "MEM-S20": content = <TransactionTransferPage transactionId={Number(params.transactionId)} />; break;
        case "MEM-S06": content = <BenefitCreatePage />; break;
        case "MEM-S16": content = <BenefitDetailPage claimId={Number(params.claimId)} />; break;
        case "MEM-S08": content = <InquiryListPage />; break;
        case "MEM-S09": content = <InquiryCreatePage />; break;
        case "MEM-S17": content = <InquiryDetailPage inquiryId={Number(params.inquiryId)} />; break;
        default: content = <AccountPageRouter routeId={route.id} />;
      }
      const settlement = ["MEM-S18", "MEM-S20"].includes(route.id);
      return <div className={`member-secondary-screen${["MEM-S04", "MEM-S08", "MEM-S09", "MEM-S16", "MEM-S17", "MEM-S18", "MEM-S20", "MEM-S11", "MEM-S15"].includes(route.id) ? " member-secondary-screen--mint" : ""}${settlement ? " member-secondary-screen--settlement" : ""}`}>
        {!settlement && <MemberTopBar title={["MEM-S08", "MEM-S09"].includes(route.id) ? "1:1 문의" : route.title} backTo={backTarget(route.id, params)} action={["MEM-S03", "MEM-S06", "MEM-S09"].includes(route.id) ? <button type="button" className="mr-icon-button" aria-label="닫기" onClick={() => navigate(backTarget(route.id, params))}>×</button> : undefined} />}
        <div className="member-secondary-screen__content">{content}</div>
      </div>;
    }
  }
}
